module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d04-0408d4fdab872c10ca7a57e8a2593870.jpg";